import React, { useEffect } from "react";

export const useOutsideClick = (ref, callback) => {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
               if(callback && typeof callback === "function"){
                callback()
               }
            }
        }
        // Bind the event listener
        document?.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document?.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}